import React, { useEffect, useState } from 'react'
import Meta from './layout/Meta';
import '../css/career.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import CmsLoader from '../loader/Cms1';
import CareerLoader from '../loader/Career';
export default function Career() {
    const [pageloader, setPageloader] = useState(false);
    const [dataloader, setLoader] = useState(false);
    const [pagedata, setPagedata] = useState();
    const [careerlists, setcareerlists] = useState([]);
    const [career, setCareer] = useState([]);

    const [btnloader, setBtnloader] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [experience, setExperience] = useState("");
    const [resume, setResume] = useState("");
    const [job, setJob] = useState("");
    const [error, setError] = useState({ name: "", email: "", phone: "", experience: "", resume: "" });

    
    
    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/10')
                .then((response) => {
                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setPagedata]);

    useEffect(() => {
        async function getcareerdata() {
            await axios.get(process.env.REACT_APP_API + 'api/careers').then((response) => {
                setcareerlists(response.data.result.data);

            });
        }
        getcareerdata();
    }, [setcareerlists]);

    async function JobSubmit(e) {
        setError({ name: "", email: "", phone: "", experience: "", resume: "" });
        setBtnloader(true);
        e.preventDefault();
        let callback = { name: name, email: email, phone: phone, experience: experience, resume: resume, job_id: job }
        let config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        }
        await axios.post(process.env.REACT_APP_API + 'api/applyjob', callback, config)
            .then((responose) => {
                toast.success(responose.data.message);
                setBtnloader(false);
                setName("");
                setEmail("");
                setPhone("");
                setExperience("");
                setResume("");
                $('#CareerForm').modal('hide');
                $('.Carrefrm').trigger('reset');
                setError({ name: "", email: "", phone: "", experience: "", resume: "" });

            })
            .catch((errors) => {
                if (errors.response !== undefined) {
                    let rterror = errors.response.data.errors;
                    setError({
                        name: rterror?.name?.[0],
                        email: rterror?.email?.[0],
                        phone: rterror?.phone?.[0],
                        experience: rterror?.experience?.[0],
                        resume: rterror?.resume?.[0]
                    });
                    setBtnloader(false);
                }

            })
    }

    async function getcareerdtldata(id) {
        setLoader(true);
        await axios.get(process.env.REACT_APP_API + 'api/careers/' + id).then((response) => {
            setCareer(response.data.result);
            setLoader(false);
        });
    }

    return (
        <>
            <Meta id={11} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Careers" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Careers</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Careers</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    pageloader ?
                        <section>
                            <div className='container'>
                                <CareerLoader />
                            </div>
                        </section>
                        :
                        <section>
                            <div className="container">
                                {
                                    pagedata ?
                                        <div className="row mb-4 justify-content-center">
                                            <div className="col-lg-9 col-md-10 text-center">
                                                <span className="SubTitle">{pagedata.title}</span>
                                                <h2 className="Heading">{pagedata.heading}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }

                                <div className="row justify-content-center">
                                    <div className="col-lg-9 col-md-11 mb-4">
                                        {
                                            careerlists.map((lists, a) =>
                                                <div key={a} className="card card-body Openings mb-4 px-md-4 py-md-4 justify-content-between align-items-center flex-md-row">
                                                    <div>
                                                        <h3 className="h5 m-0 fw-bold">{lists.title}</h3>
                                                        <p className="thm3 m-0">{lists.department}</p>
                                                    </div>
                                                    <span>
                                                        <a data-bs-toggle="modal" onClick={() => getcareerdtldata(lists.id)} href="#Detail" className="btn btn-thm1 mt-md-0 me-3">Description</a>
                                                        <a data-bs-toggle="modal" onClick={() => setJob(lists.id)} href="#CareerForm" className="btn btn-thm mt-md-0">Apply Now</a>
                                                    </span>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </section>

                }

            </main>
            <div className="modal fade PopupM" id="CareerForm" tabIndex="-1" aria-labelledby="CareerFormLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form onSubmit={JobSubmit} className="modal-content Carrefrm">
                        <div className="modal-header border-0 d-none">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body pt-5 px-md-5">
                            <h3 className="fw-bold h4 thm">Apply Now</h3>
                            <p>Fill out the form below and apply to be a part of the Intelligence team.</p>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" />
                                        <label htmlFor="name" className="form-label">Name<span className="text-danger">*</span></label>
                                        {error.name ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.name}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" id="experience" value={experience} onChange={(e) => setExperience(e.target.value)} placeholder="Experience (in years)" />
                                        <label htmlFor="experience" className="form-label">Experience (in years)<span className="text-danger">*</span></label>
                                        {error.experience ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.experience}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                                        <label htmlFor="email" className="form-label">Email Address<span className="text-danger">*</span></label>
                                        {error.email ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.email}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" id="mobile" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Contact Number" />
                                        <label htmlFor="mobile" className="form-label">Contact Number<span className="text-danger">*</span></label>
                                        {error.phone ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.phone}</span> : ''}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="formFileLg" className="form-label">Upload your resume<span className="text-danger">*</span></label>
                                    <div className="form-floating mb-3">
                                        <input className="form-control" id="formFileLg" onChange={(e) => setResume(e.target.files[0])} type="file" />
                                    </div>
                                    {error.resume ? <span style={{ color: "#e66a6a", fontSize: "14px" }} className='error'>{error.resume}</span> : ''}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer pt-4 border-top pb-5 d-block text-center">
                            <p>Please take a minute to review if the above details are correct.</p>
                            <button type="button" className="btn btn-thm1" data-bs-dismiss="modal">Close</button>
                            {
                                btnloader ?
                                    <button type="button" className="btn btn-thm disabled"><FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" /> Loading...</button>
                                    :
                                    <button className="btn btn-thm">Submit Application</button>
                            }
                        </div>
                    </form>
                </div>
            </div>
            <div className="modal fade" id="Detail" tabIndex="-1" aria-labelledby="CareerFormLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <form action="#" className="modal-content">
                        <div className="modal-header border-0 d-none">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body CmsPage px-md-4">
                            {
                                dataloader ? 
                                <CmsLoader/>
                                :
                                    <>
                                        <h2>{career.title ?? ''}</h2>
                                        <p>{career.department ?? ''}</p>
                                        <div dangerouslySetInnerHTML={{ __html: career.description ?? '' }} />
                                    </>
                            }

                        </div>
                        <div className="modal-footer border-top d-block text-center">
                            <button type="button" className="btn btn-thm1 btn-sm mt-0" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>
            </div>
           
        </>
    )
}
